// Where to go after signing in: the page someone was sent away from. Only a path of this portal —
// never another host (//evil.example) — so a link cannot send a customer off after a sign-in.

export function safeNext(value: unknown): string | undefined {
  if (typeof value !== "string") return undefined;
  if (!value.startsWith("/") || value.startsWith("//") || value.startsWith("/\\")) return undefined;
  if (/^\/(login|forgot|password|invitation|choose-company|new-phone)(\/|\?|$)/.test(value)) return undefined;
  return value.length <= 500 ? value : undefined;
}

export function validateNextSearch(search: Record<string, unknown>): { next?: string } {
  const next = safeNext(search.next);
  return next ? { next } : {};
}
